import React, { useState, useEffect } from "react";
import EmployeeDetails from "./EmployeeDetails";
import { createItem, attachFile } from "../mondayApi";
import Spinner from "./Spinner";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Checkbox, FormControlLabel } from "@mui/material";
import { htmlTemplate, sendEmail } from "./aws";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import {createUser, updateUser, upload} from "../apiV2";

function Form() {
  const [employeeDetails, setEmployeeDetails] = useState({});

  const [spinnerShowing, setSpinnerShowing] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [ageCheck, setAgeCheck] = useState(false);
  const [carCheck, setCarCheck] = useState(false);
  const [hoursCheck, setHoursCheck] = useState(false);

  const [sourceDetails, setSourceDetails] = useState({});
  let location = useLocation();

  useEffect(() => {
    let locObj = queryString.parse(location.search);
    setSourceDetails({ ...locObj });
  }, [location]);

  const submitEmployeeDetails = (data) => {
    setEmployeeDetails(data);
    setDialogOpen(true);
  };

  const complete = async () => {
    setDialogOpen(false);
    let formatPhone = employeeDetails.phone
      .replace(/\s/g, "")
      .replace("+", "")
      .substring(1);
    let attrs = {
      display_name: employeeDetails.name,
      phone_number: formatPhone,
      personal_email: employeeDetails.email,
      city: employeeDetails.city,
      state: employeeDetails.state,
      zip: employeeDetails.zip,
      has_vehicle: carCheck,
      is_eighteen: ageCheck,
      avail_m_f: hoursCheck,
      recruiting_source: sourceDetails.utm_source || "Website",
      StatusId: 125,
      department: 'FM',
      position: 'Field Marketer',
      pay_scale: 'FM - Contract Pay',
      offer_type: 'Standard',
      // text0__1: sourceDetails.utm_campaign,
      // dup__of_campaign1__1: sourceDetails.utm_content,
      // dup__of_content__1: sourceDetails.utm_medium,
    };

    console.log(attrs);

    try {
      setSpinnerShowing(true);
      // let res = await createItem(employeeDetails.name, attrs);
      let res = await createUser(attrs);
      let user = res.data;
      // console.log("real res", res);
      // let json = await res.json();json
      // console.log("json", json);
      // if (json?.error_message) alert(json.error_message);
      let id = user.id;

      if (id && employeeDetails.resume) {
        let res = await upload(id, employeeDetails.resume, 'resume');
        console.log(res);
        await updateUser(id, {resume_url: res?.data?.file?.location});
      } else {
        console.log("fail", id, employeeDetails.resume);
      }
      // else {
        alert("Form Submitted Successfully!");
        setEmployeeDetails({});
        setChecked(false);
        setAgeCheck(false);
        setCarCheck(false);
        setHoursCheck(false);

        // let id = json?.data?.create_item?.id;
        // console.log(id);

        //FIXME uncomment after testing
        // let emailBody = htmlTemplate(
        //   employeeDetails.name,
        //   employeeDetails.city + ", " + employeeDetails.state,
        //   id
        // );
        // await sendEmail(
        //   ["shannonurato@boundlessinc.com", "jay@baffoni5.com"],
        //   emailBody,
        //   "New Applicant"
        // );
      // }
    } catch (e) {
      alert(e);
    } finally {
      setSpinnerShowing(false);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 500,
        backgroundColor: "white",
        paddingLeft: 16,
        paddingRight: 16,
      }}
    >
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Are you sure you want to submit an employment application for ${employeeDetails.name}?`}
        </DialogTitle>
        <DialogContent>
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => setAgeCheck(e.target.checked)}
                checked={ageCheck}
              />
            }
            label={`I understand that I must be at least 18 years old to apply for this position.`}
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => setCarCheck(e.target.checked)}
                checked={carCheck}
              />
            }
            label={`I acknowledge that this job requires a personal vehicle and that I have one available.`}
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => setHoursCheck(e.target.checked)}
                checked={hoursCheck}
              />
            }
            label={`I am available to work full-time Monday through Friday.`}
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => setChecked(e.target.checked)}
                checked={checked}
              />
            }
            label={`I understand that this form is active and submitting will notify Boundless staff that
            ${employeeDetails.name} intends to apply for employment.`}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button disabled={!checked} onClick={complete} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {spinnerShowing && <Spinner />}
      <EmployeeDetails
        setData={submitEmployeeDetails}
        defaultData={employeeDetails}
      />
    </div>
  );
}

export default Form;
